<template>
  <Teleport to="body">
    <div
      class="modalBg modalHeight w-full flex items-center justify-center mobOnly:px-12"
      @click.self="background"
    >
      <div
        class="bg-lightest w-full max-w-556 p-16 desk:p-32 max-h-[80vh] overflow-y-auto shadow-xl relative z-modalsContent"
        :class="{'max-w-desktopMd': isSideBySideComparison}"
      >
        <div v-if="message" class="type-headline-base mb-16">
          {{ message }}
        </div>
        <slot />
        <div class="flex flex-row flex-wrap items-center justify-end gap-y-8 gap-x-16">
          <button
            v-if="showAbort"
            class="btn btn--secondary"
            :class="{ 'w-full': fullWidthButton }"
            type="button"
            @click="abort"
          >
            {{ abortText ? abortText : $t('modal.generic.abort') }}
          </button>
          <button
            v-if="showConfirm"
            class="btn"
            :class="{ 'w-full': fullWidthButton }"
            type="button"
            @click="confirm"
          >
            {{ confirmText ? confirmText : $t('modal.generic.ok') }}
          </button>
        </div>
        <button
          v-if="closeIcon"
          class="absolute top-8 right-8 desk:top-24 desk:right-24 p-8 text-icon-subtle hover:text-icon-base transition-all"
          type="button"
          @click="close"
        >
          <GlobalIcon name="close" size="small" />
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const { $t } = useNuxtApp();
const props = withDefaults(defineProps<{
  message?: string,
  showAbort?: boolean,
  showConfirm?: boolean,
  abortText?: string,
  confirmText?: string,
  isSideBySideComparison?: boolean,
  closeIcon?: boolean,
  fullWidthButton?: boolean,
}>(), {
  message: '',
  showAbort: () => false,
  showConfirm: () => true,
  isSideBySideComparison: () => false,
  closeIcon: () => false,
  fullWidthButton: () => false,
  abortText: '',
  confirmText: '',
});

const emit = defineEmits<{
  (e: 'abort'): void;
  (e: 'confirm'): void;
  (e: 'close'): void;
  (e: 'clickOutside'): void;
}>();

const background = () => {
  if (!props.showAbort) {
    emit('confirm');
  }
  emit('close');
  emit('clickOutside');
};

const confirm = () => {
  emit('confirm');
  emit('close');
};

const abort = () => {
  emit('abort');
  emit('close');
};

const close = () => {
  emit('close');
};

</script>
